
const EstadosDeAsociado = {
    HAB: "Habilitado",
    DHAB: "En Baja",
};

export {EstadosDeAsociado };
